export const defaultFun = () => {}
export const formattingNumber = function(number, digit = 0, unit = 1) {
    const regex = /\B(?=(\d{3})+\b)/g;
    number = Number(number) / unit
    return number.toFixed(digit).replace(regex, ',')
}
